<template>
  <b-card no-body>
    <b-card-header class="py-2 ct-header">
      <strong>Castes (जात / समाज)</strong>
      <small class="ml-2">All castes in the system (source: ObcCastes). Use “Run Report” to filter the Master Report by a caste.</small>
    </b-card-header>
    <b-card-body>
      <b-row class="mb-2">
        <b-col md="6">
          <b-input-group size="sm">
            <b-form-input
              v-model="search"
              type="search"
              placeholder="Search caste name / category…"
            ></b-form-input>
            <b-input-group-append>
              <b-button size="sm" :disabled="!search" @click="search = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col md="6" class="text-right" v-if="filteredRows.length">
          <json-excel :data="excelRows" :name="'Castes.xls'" class="d-inline-block">
            <b-button size="sm" variant="success"><i class="fa fa-file-excel"></i> Excel</b-button>
          </json-excel>
        </b-col>
      </b-row>

      <b-table
        small
        bordered
        striped
        hover
        responsive
        head-variant="dark"
        :items="filteredRows"
        :fields="fields"
        :busy="isLoading"
        :per-page="perPage"
        :current-page="currentPage"
        style="font-size: 13px"
      >
        <template v-slot:table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="ml-2">Loading castes…</strong>
          </div>
        </template>
        <template v-slot:cell(action)="row">
          <b-button size="sm" variant="info" class="py-0" @click="$emit('select', row.item.id)">
            Run Report
          </b-button>
        </template>
      </b-table>

      <b-row v-if="totalRows > perPage">
        <b-col md="6" class="my-1">
          <small class="text-muted">Total castes: {{ totalRows }}</small>
        </b-col>
        <b-col md="6" class="my-1">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="right"
            size="sm"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>

      <b-alert v-if="!isLoading && rows.length === 0" show variant="warning" class="mt-2 mb-0">
        No castes returned by the master API.
      </b-alert>
    </b-card-body>
  </b-card>
</template>

<script>
import apis from "@/apis";
import JsonExcel from "vue-json-excel";

export default {
  name: "Castes",
  components: { JsonExcel },
  data() {
    return {
      rows: [],
      isLoading: false,
      search: "",
      perPage: 25,
      currentPage: 1,
      fields: [
        { key: "sr", label: "#" },
        { key: "casteName", label: "Caste / समाज", sortable: true },
        { key: "category", label: "Category", sortable: true },
        { key: "action", label: "Report" }
      ]
    };
  },
  computed: {
    filteredRows() {
      const q = this.search.trim().toLowerCase();
      if (!q) return this.rows;
      return this.rows.filter(
        r =>
          (r.casteName || "").toLowerCase().indexOf(q) !== -1 ||
          (r.category || "").toLowerCase().indexOf(q) !== -1
      );
    },
    totalRows() {
      return this.filteredRows.length;
    },
    excelRows() {
      return this.filteredRows.map(r => ({
        "#": r.sr,
        "Caste / समाज": r.casteName,
        Category: r.category
      }));
    }
  },
  mounted() {
    this.loadCastes();
  },
  methods: {
    // CasteName from the API is e.g. "VJ-A  कचकीवाले बंजारा".
    // Extract the category prefix (everything before the first space cluster).
    extractCategory(casteName) {
      if (!casteName) return "";
      const m = casteName.match(/^([A-Z][A-Z0-9\-]*)/);
      return m ? m[1] : "";
    },
    loadCastes() {
      this.isLoading = true;
      apis
        .getCaste()
        .then(res => {
          const list = res && res.status === 200 && Array.isArray(res.body) ? res.body : [];
          this.rows = list.map((c, i) => ({
            id: c.CasteID || c.id,
            sr: i + 1,
            casteName: c.CasteName || c.name || "",
            category: this.extractCategory(c.CasteName || c.name || "")
          }));
          this.isLoading = false;
        })
        .catch(() => {
          this.rows = [];
          this.isLoading = false;
        });
    }
  }
};
</script>

<style scoped>
.ct-header {
  background-color: #0a0032;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/AdminReports/Castes.vue